import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { CampaignSchema as CampaignBaseSchema, CampaignValidationSchema, ProductSchema } from "model/_base";
import { ERROR_MESSAGES } from "constants/validation";

// Yup Schemas
export const CampaignWithProductSchema = CampaignBaseSchema.clone()
  .transform(transformSnakeToCamel)
  .shape({
    products: Yup.array().of(ProductSchema).nullable(), // Loose for loading
  });

export const CampaignWithProductValidationSchema = CampaignValidationSchema.clone()
  .transform(transformSnakeToCamel)
  .shape({
    products: Yup.array()
      .of(ProductSchema)
      .min(1, ERROR_MESSAGES.PRODUCT_MIN_REQUIRED)
      .required(ERROR_MESSAGES.PRODUCT_MIN_REQUIRED),
  });

export class CampaignModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = CampaignWithProductSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
